import { render, staticRenderFns } from "./BasesTab.vue?vue&type=template&id=f822071e"
import script from "./BasesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BasesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports